import React from 'react';

interface SidebarFieldProps {
  label: string;
  children: React.ReactNode;
  onClick?: () => void;
  clickable?: boolean;
  ariaLabel?: string;
  'data-testid'?: string;
}

export const SidebarField: React.FC<SidebarFieldProps> = ({
  label,
  children,
  onClick,
  clickable = false,
  ariaLabel,
  'data-testid': dataTestId,
}) => {
  const valueContent = (
    <div
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded transition-colors ${
        clickable ? 'cursor-pointer' : ''
      }`}
      data-testid={dataTestId}
      onMouseEnter={clickable ? (e) => {
        e.currentTarget.style.backgroundColor = 'var(--theme-button-ghost-hover, #f1f5f9)';
      } : undefined}
      onMouseLeave={clickable ? (e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      } : undefined}
      onClick={clickable ? onClick : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      } : undefined}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );

  return (
    <div
      className="flex items-center justify-between py-1.5"
      style={{ borderBottom: '1px solid var(--theme-card-border, #f1f5f9)' }}
    >
      <span
        className="text-xs"
        style={{ color: 'var(--theme-muted-text, #64748b)' }}
      >
        {label}
      </span>
      {valueContent}
    </div>
  );
};
